// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
// 先引入第三方组件
import ElementUI from "element-ui";
import "./assets/style/theme/index.css";
// import "element-ui/lib/theme-chalk/index.css";
// 后引入自定义样式和router
import "../static/css/common.css";
import router from "./router";
import axios from "axios";
import library from "./js/library";
import consts from "./js/consts";
import "./assets/icon/iconfont.css";
import i18n from "./i18n";
import VueClipboards from "vue-clipboard2";
import watermark from "./js/watermark";

// import vueEsign from 'vue-esign'

import { VueOkrTree } from "vue-okr-tree";
// import 'vue-okr-tree/dist/vue-okr-tree.css'
import "./assets/style/okr/vue-okr-tree.css";
Vue.component("vue-okr-tree", VueOkrTree);

Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
Vue.config.productionTip = false;

Vue.use(VueClipboards);
Vue.prototype.$watermark = watermark;

// Vue.use(vueEsign)
// function getWebBaseUrl() {
//     return "http://127.0.0.1:9080";
//     // return 'http://47.100.27.141:9002';
// }

import htmlToPdfByPage from "@/js/htmlToPdfByPage";
Vue.use(htmlToPdfByPage);



Vue.prototype.$http = axios;
// Vue.prototype.$baseRestUrl = getWebBaseUrl();

// Vue.prototype.$http.defaults.baseURL = 'http://139.196.44.157:9000';
// Vue.prototype.$http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
Vue.prototype.$http.defaults.timeout = 120000;

Vue.prototype.req = library.req;
Vue.prototype.reqCache = library.reqCache;
Vue.prototype.reqAsy = library.reqAsy;
Vue.prototype.export = library.export;
Vue.prototype.fmoney = library.fmoney;
Vue.prototype.funAuth = library.funAuth;
Vue.prototype.downLoad = library.downLoad;
Vue.prototype.envPath = library.envPath;
Vue.prototype.isImg = library.isImg;
Vue.prototype.isDoc = library.isDoc;
Vue.prototype.lib = library;

Vue.prototype.consts = consts;

// //引入echarts   sd
// import echarts from '/src/assets/echarts.min.js'
// Vue.prototype.$echarts = echarts

String.prototype.endWith = function(endStr) {
    var d = this.length - endStr.length;
    return d >= 0 && this.lastIndexOf(endStr) == d;
};
String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
};

Vue.filter("fmoney", library.fmoney);
Vue.filter("timeFormat", library.timeFormat);
Vue.filter("nameChar", library.nameChar);
Vue.filter("nameToColor", library.nameToColor);
Vue.filter("lastChar", library.lastChar);
Vue.filter("numToLetter", library.numToLetter);
Vue.filter("qstAnswerFmt", library.qstAnswerFmt);

Vue.component("Editor", () => import("@/plugins/ue"));
Vue.component("loc-file-kit", () => import("@/plugins/locFileKit"));
// Vue.component("hsign", ()=> import("@/plugins/hsign"));
// Vue.component("oss-kit", () => import("@/plugins/ossKit"));
// Vue.component("att-kit", () => import("@/plugins/attKit"));
Vue.component("chart-base", () => import("@/plugins/chartBase"));
Vue.component("chart-table", () => import("@/plugins/chartTable"));
Vue.component("top-nav", () => import("@/plugins/topNav"));
Vue.component("qst-zoom", () => import("@/plugins/qstZoom"));

import * as filters from "./filters/index";
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    i18n,
    data: function() {
        return {
            LOGINSTATUS: true
        };
    },
    components: { App },
    template: "<App/>",
    mounted: function() {
        this.$nextTick(function() {
            // 初始加载行政区域新
            // let _this = this;
            // this.req(
            //     "/chinastates/get_children?pcode=0001",
            //     {},
            //     function(data) {
            //         if (data.success) {
            //             Vue.prototype.chinastatesMap = data.obj;
            //         }
            //     },
            //     "get"
            // );

            document.title = config.sysName;
            // let types = "SYS_PARAM_SYS_NAME";
            // this.req(
            //     "/common/qry_sys_param_mult?types=" + types,
            //     {},
            //     function(data) {
            //         if (data.success) {
            //             document.title = data.obj["SYS_PARAM_SYS_NAME"].value;
            //         }
            //     },
            //     "get"
            // );
        });
    }
});



// WEBPACK FOOTER //
// ./src/main.js